import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { APP_PRIVATE_PATHS } from '@epicuro-next/navigation/constants';

export const clearUrlParamsGuardFactory = (
  keepParamsPaths: string[] = [],
): CanDeactivateFn<unknown> => {
  return (
    _,
    __: ActivatedRouteSnapshot,
    ___: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ) => {
    if (
      keepParamsPaths.length &&
      keepParamsPaths.some((keepParamsPath) =>
        nextState.url.includes(keepParamsPath),
      )
    ) {
      return true;
    }

    // params will be cleared (overridden) in search-bar component when redirect is triggered with default queryParamsHandling: '' and all p-basket params
    if (nextState.url.includes(`/${APP_PRIVATE_PATHS.search.path}`)) {
      return true;
    }
    if (nextState.url.includes('?')) {
      return inject(Router).parseUrl(nextState.url.replace(/\?.*/, ''));
    }

    return true;
  };
};
